import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-43eebb99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-input-icon-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ProductMultiSelect = _resolveComponent("ProductMultiSelect")!
  const _component_CategoryMultiSelect = _resolveComponent("CategoryMultiSelect")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    dataKey: "id",
    "auto-layout": "",
    rowHover: false,
    rows: 20,
    "rows-per-page-options": _ctx.rowsPerPageOptions,
    value: _ctx.resume.storable,
    filters: _ctx.filters,
    "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
    onFilter: _ctx.onFilter,
    filterDisplay: "menu",
    showGridlines: "",
    responsiveLayout: "scroll",
    globalFilterFields: ['name', 'category.label'],
    class: "p-datatable-sm p-mt-2",
    scrollable: "",
    "scroll-height": "flex",
    style: {"height":"calc(100vh - 192px)"}
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "p-button-sm p-button-outlined p-button-rounded",
        icon: "pi pi-refresh",
        label: _ctx.$t('clear'),
        onClick: _ctx.clearFilter
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        disabled: !_ctx.resume.storable.length,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.print())),
        label: _ctx.$t('pos.print'),
        icon: "pi pi-print"
      }, null, 8, ["disabled", "label"]),
      _createElementVNode("span", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_InputText, {
          modelValue: _ctx.filters.global.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.global.value) = $event)),
          placeholder: _ctx.$t('search'),
          style: {"width":"100%"}
        }, null, 8, ["modelValue", "placeholder"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        "show-add-button": false,
        showFilterOperator: false,
        header: _ctx.$t('product.reference'),
        filterField: "reference",
        field: "reference",
        sortable: true,
        "sort-field": "reference"
      }, {
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            placeholder: _ctx.$t('product.filterByRef')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-mr-1",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-search",
            class: "p-button-success",
            label: _ctx.$t('search')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "name",
        "show-filter-match-modes": false,
        "show-add-button": false,
        showFilterOperator: false,
        sortable: true,
        "filter-field": "id",
        "sort-field": "name",
        header: _ctx.$t('product.product')
      }, {
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_ProductMultiSelect, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            items: _ctx.resume.storable,
            style: {"max-width":"220px"}
          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-button-sm",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('search'),
            type: "button",
            icon: "pi pi-database",
            class: "p-button-sm p-ml-2",
            onClick: ($event: any) => (filterCallback())
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        showFilterMatchModes: false,
        "show-add-button": false,
        showFilterOperator: false,
        field: "category.label",
        sortable: true,
        "filter-field": "category.id",
        "sort-field": "category.label",
        header: _ctx.$t('product.category')
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.category.label), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_CategoryMultiSelect, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            items: _ctx.resume.categories,
            style: {"max-width":"220px"}
          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-button-sm",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('search'),
            type: "button",
            icon: "pi pi-database",
            class: "p-button-sm",
            onClick: ($event: any) => (filterCallback())
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        "show-add-button": false,
        showFilterOperator: false,
        field: "purchasePrices",
        header: _ctx.$t('product.purchasePrice'),
        filterField: "purchasePrices",
        filterMatchModeOptions: _ctx.priceMatchModeOptions,
        sortable: true,
        "sort-field": "purchasePrices"
      }, {
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_InputNumber, {
            type: "text",
            onKeyup: _withKeys(filterCallback, ["enter"]),
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            modelModifiers: { number: true },
            class: "p-column-filter"
          }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-search",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-success p-ml-1",
            label: _ctx.$t('search'),
            "icon-pos": "right"
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header", "filterMatchModeOptions"]),
      _createVNode(_component_Column, {
        "show-add-button": false,
        showFilterOperator: false,
        header: _ctx.$t('product.sellingPrice'),
        filterField: "sellingPrices",
        field: "sellingPrices",
        filterMatchModeOptions: _ctx.priceMatchModeOptions,
        sortable: true,
        "sort-field": "sellingPrices"
      }, {
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_InputNumber, {
            type: "text",
            onKeyup: _withKeys(filterCallback, ["enter"]),
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            modelModifiers: { number: true },
            class: "p-column-filter"
          }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-search",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-success p-ml-1",
            label: _ctx.$t('search'),
            "icon-pos": "right"
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header", "filterMatchModeOptions"]),
      _createVNode(_component_Column, {
        "show-add-button": false,
        showFilterOperator: false,
        field: "totalPurchasePrices",
        header: _ctx.$t('product.totalPurchasePrice'),
        filterField: "totalPurchasePrices",
        filterMatchModeOptions: _ctx.priceMatchModeOptions,
        sortable: true,
        "sort-field": "totalPurchasePrices"
      }, {
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_InputNumber, {
            type: "text",
            onKeyup: _withKeys(filterCallback, ["enter"]),
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            modelModifiers: { number: true },
            class: "p-column-filter"
          }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-search",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-success p-ml-1",
            label: _ctx.$t('search'),
            "icon-pos": "right"
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header", "filterMatchModeOptions"]),
      _createVNode(_component_Column, {
        "show-add-button": false,
        showFilterOperator: false,
        header: _ctx.$t('product.totalSellingPrice'),
        filterField: "totalSellingPrices",
        field: "totalSellingPrices",
        filterMatchModeOptions: _ctx.priceMatchModeOptions,
        sortable: true,
        "sort-field": "totalSellingPrices"
      }, {
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_InputNumber, {
            type: "text",
            onKeyup: _withKeys(filterCallback, ["enter"]),
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            modelModifiers: { number: true },
            class: "p-column-filter"
          }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-search",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-success p-ml-1",
            label: _ctx.$t('search'),
            "icon-pos": "right"
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header", "filterMatchModeOptions"]),
      _createVNode(_component_Column, {
        "sort-field": "stock",
        sortable: true,
        field: "stock",
        header: _ctx.$t('stock.stock'),
        "show-add-button": false,
        showFilterOperator: false,
        "filter-field": "stock",
        dataType: "numeric"
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(_component_NumberFormatter, {
            value: data.stock
          }, null, 8, ["value"])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputNumber, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            "max-fraction-digits": 20,
            min: 0,
            mode: "decimal"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-button-sm",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('search'),
            type: "button",
            icon: "pi pi-search",
            class: "p-button-sm",
            onClick: ($event: any) => (filterCallback())
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        "sort-field": "threshold",
        sortable: true,
        field: "threshold",
        header: _ctx.$t('product.threshold'),
        "show-add-button": false,
        showFilterOperator: false,
        "filter-field": "threshold",
        dataType: "numeric"
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(_component_NumberFormatter, {
            value: data.threshold
          }, null, 8, ["value"])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputNumber, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            "max-fraction-digits": 20,
            min: 0,
            mode: "decimal"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-button-sm",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('search'),
            type: "button",
            icon: "pi pi-search",
            class: "p-button-sm",
            onClick: ($event: any) => (filterCallback())
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        "sort-field": "gap",
        sortable: true,
        field: "gap",
        header: _ctx.$t('stock.gap'),
        "show-add-button": false,
        showFilterOperator: false,
        "filter-field": "gap",
        dataType: "numeric"
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(_component_NumberFormatter, {
            value: data.gap
          }, null, 8, ["value"])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputNumber, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            "max-fraction-digits": 20,
            min: 0,
            mode: "decimal"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-button-sm",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('search'),
            type: "button",
            icon: "pi pi-search",
            class: "p-button-sm",
            onClick: ($event: any) => (filterCallback())
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_ColumnGroup, { type: "footer" }, {
        default: _withCtx(() => [
          _createVNode(_component_Row, null, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                footer: _ctx.$t('payment.total'),
                colspan: 5
              }, null, 8, ["footer"]),
              _createVNode(_component_Column, {
                footer: `${_ctx.formatNumber(
            _ctx.filteredTotals.totalPurchasePrices
          )} ${_ctx.currencySymbol}`
              }, null, 8, ["footer"]),
              _createVNode(_component_Column, {
                footer: `${_ctx.formatNumber(
            _ctx.filteredTotals.totalSellingPrices
          )} ${_ctx.currencySymbol}`
              }, null, 8, ["footer"]),
              _createVNode(_component_Column, {
                colspan: 3,
                footer: `${_ctx.formatNumber(_ctx.filteredTotals.stock)}`
              }, null, 8, ["footer"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["rows-per-page-options", "value", "filters", "onFilter"]))
}